import { z } from 'zod';

export const createQuestionSchema = z.object({
  text: z
    .string()
    .min(1, 'Question text is required')
    .max(1000, 'Question text must be at most 1000 characters'),
  isRequired: z.boolean(),
});

export const updateQuestionSchema = z.object({
  text: z
    .string()
    .min(1, 'Question text is required')
    .max(1000, 'Question text must be at most 1000 characters'),
  isRequired: z.boolean(),
  sortOrder: z.number().optional(),
});

export type CreateQuestionFormData = z.infer<typeof createQuestionSchema>;
export type UpdateQuestionFormData = z.infer<typeof updateQuestionSchema>;
